import axios from 'axios';

const BASE_URL = '/iapi';
const USER_INFO_URL = `${BASE_URL}/user`;

export function getUserInfo() {
  return axios.get(USER_INFO_URL).then(res => (res)).catch();
}
